import { render, staticRenderFns } from "./DraftEditor.vue?vue&type=template&id=4f47150e&scoped=true"
import script from "./DraftEditor.vue?vue&type=script&lang=js"
export * from "./DraftEditor.vue?vue&type=script&lang=js"
import style0 from "./DraftEditor.vue?vue&type=style&index=0&id=4f47150e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f47150e",
  null
  
)

export default component.exports